/**
 * The current section, pinned while you are inside it.
 *
 * Once you have scrolled past a `##` in a lecture-length answer you lose track
 * of which section you are in, and the outline only tells you if you open it.
 * This keeps the answer's own heading visible without stealing a line of
 * reading space when there is nothing to show.
 */

import { MathText } from "../markdown/MathText.tsx";
import type { OutlineEntry } from "./AnswerOutline.tsx";

interface StickyHeadingProps {
  readonly entries: readonly OutlineEntry[];
  readonly activeId: string | null;
}

export function StickyHeading({ entries, activeId }: StickyHeadingProps) {
  const active = entries.find((entry) => entry.id === activeId);
  if (!active) return null;

  return (
    <div
      aria-hidden="true"
      className="no-print sticky top-0 z-20 -mx-2 mb-2 truncate border-b border-border bg-background/85 px-2 py-1.5 font-sans text-xs text-muted-foreground backdrop-blur-sm"
    >
      <MathText children={active.text} />
    </div>
  );
}
